var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1041_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C17.5894 48 11.5624 45.5036 7.02938 40.9706C2.49638 36.4376 0 30.4106 0 24C0 17.5894 2.49647 11.5625 7.02938 7.02938C11.5623 2.49628 17.5894 0 24 0C30.4106 0 36.4376 2.49638 40.9706 7.02938C45.5036 11.5624 48 17.5894 48 24C48 30.4106 45.5035 36.4375 40.9706 40.9706C36.4377 45.5037 30.4106 48 24 48ZM24 3C12.4206 3 3 12.4206 3 24C3 35.5794 12.4206 45 24 45C35.5794 45 45 35.5794 45 24C45 12.4206 35.5794 3 24 3Z",
    fill: "#4A8AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2442 14.6045H27.3677C28.0682 15.4945 28.5118 16.5825 28.6978 17.8682H32L31.2442 20.4724H28.7475C28.5502 22.4286 27.7782 23.901 26.4312 24.89C25.0842 25.879 23.2115 26.3737 20.813 26.3737L28.9117 35.802V36H25.1825L16.4764 25.8297L16.4598 23.7696H20.5502C21.9194 23.7583 23.0307 23.4613 23.8851 22.8792C24.7392 22.2859 25.2811 21.4836 25.5112 20.4724H16L16.7554 17.8682H25.4784C24.9524 15.7803 23.3429 14.6926 20.6488 14.6045H16.0331L16.8048 12H32L31.2442 14.6045Z",
    fill: "#4A8AF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus4);
export default __webpack_public_path__ + "static/media/whyus4.7fc673b10a6184bb09293882821b629c.svg";
export { ForwardRef as ReactComponent };